import dayjs from 'dayjs';
import { cn, FormatUtils } from '@shared/utils';
import type { GetAllCardsResponse } from '@shared/api';
import { Card } from './card';
import { Invoices } from './invoices';
import { Statements } from './statements';
import { Button, Tabs } from '@shared/widgets';

interface ICardInfoProps {
  className?: string;
  card: GetAllCardsResponse;
  index: number;
  selectedCard?: GetAllCardsResponse;
  onManageCard: (card: GetAllCardsResponse, index: number) => void;
  onClick: (card: GetAllCardsResponse) => void;
}

export const CardInfo = (props: ICardInfoProps) => {
  const tabs = [
    { label: 'Invoices', content: <Invoices card={props.card} /> },
    { label: 'Statements', content: <Statements card={props.card} /> },
  ];
  return (
    <div
      className={cn(
        'pb-[91px]',
        'max-md:hidden',
        props.selectedCard && 'hidden',
        props.selectedCard && props.selectedCard?.id === props.card.id && 'block',
        props.className,
      )}
    >
      <div className='flex justify-center'>
        <Card card={props.card} />
        <div className='ml-6'>
          {props.selectedCard?.id === props.card.id && (
            <Button className='mb-9 w-[200px]' onClick={() => props.onManageCard(props.card, props.index)}>
              Manage Card
            </Button>
          )}
          <div
            className='flex h-[46px] w-[399px] cursor-pointer items-center justify-between rounded border-2 border-[#f2f3f5] bg-white pr-4 pl-3 text-[#d0021b]'
            onClick={() => props.onClick(props.card)}
          >
            {props.card.paymentDue ? (
              <div className='flex items-center'>
                <span className='mr-3 inline-block h-[22px] w-[22px] rounded-full bg-[#b70000] text-center font-bold text-white'>!</span>
                <span>Payment due on {dayjs(props.card.paymentDue || new Date()).format('DD MMM YYYY')}</span>
              </div>
            ) : (
              <span className='text-[#4c4c4c]'>Invoices and Statements</span>
            )}

            <i className='inline-block h-[9px] w-[9px] -rotate-45 border-r-2 border-b-2 border-[#c1c1c1] p-1 text-right' />
          </div>
          <div className='mt-4'>
            <div className='mb-2'>
              Statement Balance:
              <span
                className={cn('ml-1', props.card.statementBalance <= 0 && 'text-[#d0021b]')}
              >{`${props.card.currency} ${FormatUtils.insertSpaces(props.card.statementBalance) || '57,383'}`}</span>
            </div>
            <div className='mb-2'>
              New Charges: <span>{`${props.card.currency} ${FormatUtils.insertSpaces(props.card.newCharges) || '1,028,438'}`}</span>
            </div>
            <div className='mb-2'>
              New Credits: <span>{`${props.card.currency} ${FormatUtils.insertSpaces(props.card.newCredits) || '1,030,511'}`}</span>
            </div>
            <div className='mb-2'>
              Previous Balance:
              <span
                className={cn('ml-1', props.card.previousBalance <= 0 && 'text-[#d0021b]')}
              >{`${props.card.currency} ${FormatUtils.insertSpaces(props.card.previousBalance) || '59,463'}`}</span>
            </div>
          </div>
        </div>
      </div>
      {props.selectedCard?.id === props.card?.id && <Tabs tabs={tabs} />}
    </div>
  );
};
